module.exports = __webpack_public_path__ + "static/media/gwp_60y_y-1.8d30cc07.csv";